<template>
  <div>
    <PaymentListItem
      v-for="item of list"
      :patient-info="item.patient_info"
      :price="item.current_price"
      :key="item.patient_info.image_id"/>
  </div>
</template>

<script>
import PaymentListItem from './PaymentListItem.vue';

export default {
  name: 'PaymentList',
  components: {
    PaymentListItem,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
